document.addEventListener('DOMContentLoaded', function () {
  const hideInfoSessionInput = document.getElementById(
    'hide-info-session-input'
  );
  const hideInfoSessionLabel = document.getElementById(
    'hide-info-session-label'
  );

  if (!hideInfoSessionInput || !hideInfoSessionLabel) {
    return;
  }

  const attributes = hideInfoSessionInput.getAttribute(
    'data-events-categories'
  );
  if (!attributes) {
    return;
  }

  const eventsCategories = JSON.parse(attributes);
  if (!eventsCategories) {
    return;
  }

  const values = Object.values(eventsCategories);
  if (values.length === 0) {
    return;
  }

  const listing = document.querySelector('.listing--events');
  if (!listing) {
    return;
  }

  const FWP = window.FWP || {};

  hideInfoSessionInput.addEventListener('change', function (el) {
    listing.classList.add('loading');
    const isChecked = el.target.checked;
    if (isChecked) {
      FWP.facets.hide_info_sessions = values;
      FWP.fetchData();
    } else {
      FWP.reset();
    }
  });
  hideInfoSessionLabel.addEventListener('click', function () {
    hideInfoSessionInput.checked = !hideInfoSessionInput.checked;
    hideInfoSessionInput.dispatchEvent(new Event('change'));
  });
  document.addEventListener('facetwp-loaded', function () {
    listing.classList.remove('loading');
  });
});
